// TODO: REFACTORING
import React, { useState, useEffect } from 'react';
import Style from './style.module.css';

const TabSection = ({ sections, headerClassName, activeIndex = 0 }) => {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setActiveTab(activeIndex);
  }, [activeIndex]);

  const header = sections.map((section, index) => {
    if (section.onClick)
      return (
        <div
          key={index}
          data-test={section?.test || ''}
          onClick={section.onClick}
          className={activeTab == index ? Style.active_title : Style.title}
        >
          {' '}
          {section.title}{' '}
        </div>
      );
    else {
      if (section.title) {
        return (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            data-test={section?.test || ''}
            className={activeTab == index ? Style.active_title : Style.title}
          >
            {' '}
            {section.title}{' '}
          </div>
        );
      } else {
        return null;
      }
    }
  });

  return (
    <div>
      {sections.length > 1 && (
        <div
          className={[
            Style.header,
            headerClassName ? headerClassName : '',
          ].join(' ')}
        >
          {header}
        </div>
      )}
      <div
        className={Style.content}
        data-test={sections[activeTab]?.test || ''}
      >
        {sections[activeTab].content}
      </div>
    </div>
  );
};

export default TabSection;
